var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 58,
    viewBox: "0 0 64 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.375 45.9241C55.9306 45.9241 53.8465 47.4917 53.0725 49.6741H37.3025C36.7366 48.0786 35.4705 46.8124 33.875 46.2466V42.3822H53.5794C56.681 42.3822 59.2044 39.8589 59.2044 36.7572V29.1043C59.2044 26.4051 57.293 24.1447 54.7529 23.6033V19.6047C57.293 19.0633 59.2044 16.8029 59.2044 14.1037V6.45081C59.2044 3.34918 56.681 0.825806 53.5794 0.825806H10.4206C7.319 0.825806 4.79563 3.34918 4.79563 6.45081V14.1037C4.79563 16.8029 6.707 19.0633 9.24712 19.6047V23.6033C6.707 24.1447 4.79563 26.4051 4.79563 29.1043V36.7572C4.79563 39.8589 7.319 42.3822 10.4206 42.3822H30.125V46.2466C28.5295 46.8124 27.2634 48.0786 26.6975 49.6741H10.9275C10.1535 47.4917 8.06938 45.9241 5.625 45.9241C2.52338 45.9241 0 48.4473 0 51.5491C0 54.6507 2.52338 57.1741 5.625 57.1741C8.06938 57.1741 10.1535 55.6064 10.9275 53.4241H26.6975C27.4715 55.6064 29.5556 57.1741 32 57.1741C34.4444 57.1741 36.5285 55.6064 37.3025 53.4241H53.0725C53.8465 55.6064 55.9306 57.1741 58.375 57.1741C61.4767 57.1741 64 54.6507 64 51.5491C64 48.4473 61.4767 45.9241 58.375 45.9241ZM51.0028 19.7287V23.4793H12.9972V19.7287H51.0028ZM8.54562 14.1037V6.45081C8.54562 5.41693 9.38675 4.57581 10.4206 4.57581H53.5794C54.6134 4.57581 55.4544 5.41693 55.4544 6.45081V14.1037C55.4544 15.1376 54.6134 15.9787 53.5794 15.9787H10.4206C9.38675 15.9787 8.54562 15.1377 8.54562 14.1037ZM8.54562 36.7572V29.1043C8.54562 28.0704 9.38675 27.2293 10.4206 27.2293H53.5794C54.6134 27.2293 55.4544 28.0704 55.4544 29.1043V36.7572C55.4544 37.7912 54.6134 38.6322 53.5794 38.6322H10.4206C9.38675 38.6322 8.54562 37.7911 8.54562 36.7572ZM5.625 53.4241C4.59113 53.4241 3.75 52.5829 3.75 51.5491C3.75 50.5151 4.59113 49.6741 5.625 49.6741C6.65887 49.6741 7.5 50.5151 7.5 51.5491C7.5 52.5829 6.65887 53.4241 5.625 53.4241ZM32 53.4241C30.9661 53.4241 30.125 52.5829 30.125 51.5491C30.125 50.5151 30.9661 49.6741 32 49.6741C33.034 49.6741 33.875 50.5151 33.875 51.5491C33.875 52.5829 33.034 53.4241 32 53.4241ZM58.375 53.4241C57.341 53.4241 56.5 52.5829 56.5 51.5491C56.5 50.5151 57.341 49.6741 58.375 49.6741C59.409 49.6741 60.25 50.5151 60.25 51.5491C60.25 52.5829 59.409 53.4241 58.375 53.4241Z",
    fill: "url(#paint0_linear_6_341)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.61 32.4839C36.4504 31.7154 35.8264 31.1137 35.0475 30.9967C34.2739 30.8804 33.4859 31.277 33.1188 31.9677C32.7503 32.661 32.8575 33.5255 33.3824 34.1091C33.9068 34.6921 34.7666 34.88 35.4886 34.5815C36.301 34.2457 36.7894 33.349 36.61 32.4839Z",
    fill: "url(#paint1_linear_6_341)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.11 32.4839C43.9503 31.7151 43.3261 31.1135 42.547 30.9966C41.7735 30.8805 40.9858 31.2771 40.6188 31.9676C40.2503 32.661 40.3575 33.5254 40.8824 34.1091C41.4068 34.6921 42.2666 34.88 42.9886 34.5815C43.8008 34.2456 44.2894 33.349 44.11 32.4839Z",
    fill: "url(#paint2_linear_6_341)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6099 32.484C51.4503 31.7157 50.8264 31.1139 50.0478 30.9967C49.2741 30.8802 48.4858 31.277 48.1187 31.9677C47.7503 32.6609 47.8577 33.5258 48.3823 34.1092C48.9067 34.6922 49.7666 34.8801 50.4886 34.5816C51.3007 34.2457 51.7893 33.3491 51.6099 32.484Z",
    fill: "url(#paint3_linear_6_341)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2718 31.0454H14.2407C13.2052 31.0454 12.3657 31.8849 12.3657 32.9204C12.3657 33.9559 13.2052 34.7954 14.2407 34.7954H27.2718C28.3073 34.7954 29.1468 33.9559 29.1468 32.9204C29.1468 31.8849 28.3073 31.0454 27.2718 31.0454Z",
    fill: "url(#paint4_linear_6_341)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9338 10.5641C33.0808 11.3326 33.7263 11.9354 34.4958 12.0513C35.269 12.1677 36.0585 11.7711 36.4249 11.0802C36.7913 10.3894 36.6884 9.51831 36.1611 8.93769C35.6348 8.35794 34.7783 8.16631 34.0549 8.46519C33.2425 8.80106 32.7544 9.69919 32.9338 10.5641Z",
    fill: "url(#paint5_linear_6_341)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4337 10.5641C40.5837 11.3482 41.2531 11.9597 42.0416 12.0576C42.8328 12.1558 43.6285 11.7222 43.9661 10.9981C44.3043 10.2727 44.1451 9.39369 43.565 8.83919C43.0222 8.32019 42.1965 8.18157 41.5121 8.48444C40.7242 8.83307 40.2578 9.71569 40.4337 10.5641Z",
    fill: "url(#paint6_linear_6_341)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9338 10.5641C48.0808 11.3326 48.7263 11.9354 49.4958 12.0513C50.2688 12.1677 51.0586 11.7709 51.4249 11.0802C51.7914 10.3891 51.6886 9.51856 51.1611 8.93769C50.6348 8.35794 49.7783 8.16631 49.0549 8.46519C48.2425 8.80106 47.7544 9.69919 47.9338 10.5641Z",
    fill: "url(#paint7_linear_6_341)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2407 12.0453H27.2718C28.3073 12.0453 29.1468 11.2058 29.1468 10.1703C29.1468 9.13479 28.3073 8.29529 27.2718 8.29529H14.2407C13.2052 8.29529 12.3657 9.13479 12.3657 10.1703C12.3657 11.2058 13.2052 12.0453 14.2407 12.0453Z",
    fill: "url(#paint8_linear_6_341)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_341",
    x1: 32,
    y1: 0.825806,
    x2: 32,
    y2: 57.1741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_341",
    x1: 34.7741,
    y1: 30.9766,
    x2: 34.7741,
    y2: 34.7217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_341",
    x1: 42.2741,
    y1: 30.9766,
    x2: 42.2741,
    y2: 34.7216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_341",
    x1: 49.7741,
    y1: 30.9766,
    x2: 49.7741,
    y2: 34.7218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_341",
    x1: 20.7563,
    y1: 31.0454,
    x2: 20.7563,
    y2: 34.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_341",
    x1: 34.7695,
    y1: 8.32556,
    x2: 34.7695,
    y2: 12.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_341",
    x1: 42.2692,
    y1: 8.32605,
    x2: 42.2692,
    y2: 12.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_341",
    x1: 49.7695,
    y1: 8.32556,
    x2: 49.7695,
    y2: 12.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_341",
    x1: 20.7563,
    y1: 8.29529,
    x2: 20.7563,
    y2: 12.0453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2351DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2351DC",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.117c3be2e696ae7e47a49cd32d8d6501.svg";
export { ForwardRef as ReactComponent };